import { Button, Text } from "@gcs/design-system/react";
import styled from "styled-components";

export const Container = styled.div(({ theme, align }) => ({
  display: "flex",
  width: "90%",
  justifyContent: "space-between",
  flexDirection: "column",
  alignItems: `${align ? "center" : "normal"}`,
  gap: "30px",
  margin: "0 auto",
  marginTop: "50px",
  borderRadius: "12px",
  padding: "20px !important",
  backgroundColor: "white",
  boxShadow: "0px 3px 6px 0px rgba(51,51,51,0.62)",
  [theme.breakpoint.lg()]: {
    margin: "24px auto",
    padding: "40px 20px 25px 35px !important",
    flexDirection: "row",
  },
}));

export const SectionTitle = styled.div(({ theme }) => ({
  width: "100%",
  [theme.breakpoint.lg()]: {
    width: "50%",
    flexDirection: "column",
  },
}));

export const Title = styled.h1(({ theme }) => ({
  position: "relative",
  width: "100%",
  fontSize: "35px",
  fontFamily: "CAIXA Std",
  fontWeight: 700,
  color: "#005FC8",
  zIndex: "1",
  [theme.breakpoint.xl()]: {
    width: "100%",
    fontSize: "35px",
    flexDirection: "row",
  },
}));

export const SectionText = styled.div(({ theme }) => ({
  width: "100%",
  [theme.breakpoint.lg()]: {
    width: "65%",
    flexDirection: "row",
  },
}));

export const Box = styled.div(({ theme }) => ({
  width: "100%",
  fontSize: "18px",
  [theme.breakpoint.lg()]: {
    fontSize: "18px",
    flexDirection: "row",
  },
}));

export const ContainerImage = styled.div(({ theme }) => ({
  order: 1,
  display: "flex",
  flexDirection: "row",
  width: "100%",
  justifyContent: "center",
  img: {
    width: "80%",
    maxWidth: "400px",
  },
  [theme.breakpoint.lg()]: {
    order: 0,
    flexDirection: "column",
    width: "35%",
    img: {
      width: "100%",
      maxWidth: "400px",
    },
  },
}));

export const ContainerText = styled.div(({ theme, image }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  fontSize: "18px",
  [theme.breakpoint.lg()]: {
    width: image ? "56%" : "100%",
    minHeight: "300px",
  },
}));

export const Underscore = styled.div(({ theme }) => ({
  borderBottom: "8px solid #f39200",
  marginBottom: "28px",
  marginLeft: "1px",
  width: "50px",
  [theme.breakpoint.lg()]: {},
}));

export const TextStyled = styled(Text).attrs({ variant: "body02-sm" })(
  ({ theme }) => ({
    fontWeight: 400,
    width: "100%",
    color: "#454E4F",
    textAlign: "justify",

    fontSize: "19px",
    [theme.breakpoint.lg()]: {},

    "p": {
      textIndent: "1.5em",
      fontWeight: 400,
      width: "100%",
      color: "#454E4F",
      textAlign: "justify",
      fontSize: "19px",
    },
  })
);

export const CardsContainer = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "32px",
  marginTop: "20px",
  [theme.breakpoint.lg()]: {
    flexDirection: "row",
  },
}));

export const ButtonContainer = styled.div(({ theme }) => ({
  marginTop: "24px",
  display: "flex",
  justifyContent: "center",
  [theme.breakpoint.lg()]: {
    justifyContent: "flex-start",
  },
}));

export const ButtonStyled = styled(Button).attrs({
  variant: "secondary-white",
})(({ theme }) => ({
  borderRadius: "0px !important",
  marginTop: "16px",
  fontSize: "13px !important",
  border: "1px solid #005fc8 !important",
  boxShadow: "none !important",
  [theme.breakpoint.lg()]: {
    maxWidth: "240px",
  },
}));
